import React, { useState, useEffect } from 'react';
import schemaViewerService from '../services/schemaViewerService';
import PayloadViewer from '../components/schema/PayloadViewer';

const SchemaViewerPage = () => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState('');
  const [payload, setPayload] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    schemaViewerService.getEventList()
      .then(eventList => {
        setEvents(eventList);
        if (eventList.length > 0) {
          setSelectedEvent(eventList[0]);
        }
      })
      .catch(() => setError('Could not load event list.'));
  }, []);

  useEffect(() => {
    if (selectedEvent) {
      setIsLoading(true);
      schemaViewerService.getEventSchema(selectedEvent)
        .then(setPayload)
        .catch(() => {
          setError(`Could not load schema for ${selectedEvent}.`);
          setPayload(null);
        })
        .finally(() => setIsLoading(false));
    }
  }, [selectedEvent]);

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Event Payload Schema Viewer</h1>
      {error && <p className="bg-red-100 text-red-700 p-3 rounded mb-4">{error}</p>}
      
      <div className="bg-white p-4 rounded-lg shadow-md mb-6">
        <label htmlFor="event-selector" className="block text-sm font-medium text-gray-700">
          Select an Event to View its Data Payload
        </label>
        <select
          id="event-selector"
          value={selectedEvent}
          onChange={(e) => setSelectedEvent(e.target.value)}
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        >
          {events.map(event => (
            <option key={event} value={event}>{event}</option>
          ))}
        </select>
      </div>

      {isLoading ? (
        <p>Loading schema...</p>
      ) : payload ? (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold mb-2">Payload for <span className="font-mono text-blue-600">{selectedEvent}</span></h2>
            <p className="text-sm text-gray-600 mb-4">This is a sample of the data that will be sent. Click any property to copy its template path to your clipboard.</p>
            <PayloadViewer data={payload} />
        </div>
      ) : (
        <p>No schema available for the selected event.</p>
      )}
    </div>
  );
};

export default SchemaViewerPage;